var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");
lorem.supplemental = require("./supplemental");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/cz/lorem/index.js
// module id = 227
// module chunks = 0